<script>
  export let status = "";
  export let size = "normal"; // "small", "normal", "large"
  export let outline = false;
  export let text = "";

  $: normalizedStatus = String(status || "").trim().toUpperCase();
  $: displayText = text || status || "UNKNOWN";

  $: badgeStyle = getBadgeConfig(normalizedStatus);

  function getBadgeConfig(st) {
    switch (st) {
      case "APPROVED":
      case "APPROVE":
      case "SUCCESS":
      case "SUCCEEDED":
      case "HEALTHY":
      case "VERIFIED":
      case "ACTIVE":
        return {
          bg: "#dcfce7",
          color: "#15803d",
          border: "#86efac",
          dot: "#22c55e",
        };

      case "CRITICAL":
      case "FAILED":
      case "FAILURE":
      case "REJECTED":
      case "ERROR":
      case "DEBIT_FAILED":
        return {
          bg: "#fee2e2",
          color: "#b91c1c",
          border: "#fca5a5",
          dot: "#ef4444",
        };

      case "WARNING":
      case "PENDING":
      case "SUBMITTED":
      case "WAITING":
      case "REQUIRES_ACTION":
        return {
          bg: "#fef3c7",
          color: "#b45309",
          border: "#fde68a",
          dot: "#f59e0b",
        };

      case "INCOMPLETE":
      case "DRAFT":
      case "INITIATED":
      case "PARTIAL":
      case "NEW":
        return {
          bg: "#f1f5f9",
          color: "#475569",
          border: "#cbd5e1",
          dot: "#94a3b8",
        };

      case "INFO":
      case "REGISTERED":
        return {
          bg: "#e0f2fe",
          color: "#0369a1",
          border: "#bae6fd",
          dot: "#0ea5e9",
        };

      default:
        return {
          bg: "#f3f4f6",
          color: "#374151",
          border: "#d1d5db",
          dot: "#6b7280",
        };
    }
  }
</script>

<span
  class="status-badge size-{size}"
  class:outline
  style="background-color: {outline ? 'transparent' : badgeStyle.bg}; color: {badgeStyle.color}; border: 1px solid {badgeStyle.border};"
>
  <span class="status-dot" style="background-color: {badgeStyle.dot};"></span>
  <span class="status-text">{displayText}</span>
</span>

<style>
  .status-badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-weight: 600;
    border-radius: 9999px;
    white-space: nowrap;
    line-height: 1;
    font-family: inherit;
    letter-spacing: 0.3px;
  }

  .size-small {
    padding: 2px 7px;
    font-size: 11px;
  }

  .size-normal {
    padding: 4px 10px;
    font-size: 12px;
  }

  .size-large {
    padding: 6px 14px;
    font-size: 13px;
  }

  .status-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    flex-shrink: 0;
  }

  .size-large .status-dot {
    width: 8px;
    height: 8px;
  }

  .status-text {
    text-transform: uppercase;
  }
</style>
